import { cn as e } from "../cn.js";
/* empty css      */
import { getStyles as t } from "./style.js";
import n from "react";
import { jsx as r } from "react/jsx-runtime";
import { Portal as i } from "@ark-ui/react";
import { Popover as a } from "@ark-ui/react/popover";
// src/design/popover/index.tsx
var o = ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Trigger, {
	className: e(t().trigger(), i),
	...o,
	children: n
}), s = ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Indicator, {
	className: e(t().indicator(), i),
	...o,
	children: n
}), c = ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Positioner, {
	className: e(t().positioner(), i),
	...o,
	children: n
}), l = n.forwardRef(({ children: n, className: i, ...o }, s) => /* @__PURE__ */ r(a.Content, {
	ref: s,
	className: i ? e("z-floating", i) : t().content(),
	...o,
	children: n
}));
l.displayName = "Popover.Content";
var u = Object.assign(() => null, {
	Context: a.Context,
	Root: a.Root,
	Portal: i,
	Trigger: o,
	Anchor: a.Anchor,
	Indicator: s,
	Positioner: c,
	Content: l,
	Title: ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Title, {
		className: e(t().title(), i),
		...o,
		children: n
	}),
	Description: ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Description, {
		className: e(t().description(), i),
		...o,
		children: n
	}),
	Arrow: ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.Arrow, {
		className: e(t().arrow(), i),
		...o,
		children: n
	}),
	ArrowTip: ({ children: n, className: i, ...o }) => /* @__PURE__ */ r(a.ArrowTip, {
		className: e(t().arrowTip(), i),
		...o,
		children: n
	}),
	CloseTrigger: a.CloseTrigger
});
export { u as Popover };

//# sourceMappingURL=index2.js.map